export default [
  {
    key: 'fromDate',
    label: 'field.fromDate',
    rules: 'required',
    type: 'date',
    cols: 12,
  },
]
